var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1849 8.99945C12.1849 10.4845 10.9849 11.6845 9.49994 11.6845C8.01494 11.6845 6.81494 10.4845 6.81494 8.99945C6.81494 7.51445 8.01494 6.31445 9.49994 6.31445C10.9849 6.31445 12.1849 7.51445 12.1849 8.99945Z",
    stroke: "#54577A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.2016C12.1475 15.2016 14.615 13.6416 16.3325 10.9416C17.0075 9.88406 17.0075 8.10656 16.3325 7.04906C14.615 4.34906 12.1475 2.78906 9.5 2.78906C6.8525 2.78906 4.385 4.34906 2.6675 7.04906C1.9925 8.10656 1.9925 9.88406 2.6675 10.9416C4.385 13.6416 6.8525 15.2016 9.5 15.2016Z",
    stroke: "#54577A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.612f8bc833ac1f66158188ec60162532.svg";
export { ForwardRef as ReactComponent };